import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-242">
      <div className="max-w-3xl mx-auto text-center" data-id="element-243">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-244">
          Si sos profe de tenis,
          <br data-id="element-245" />
          <span className="text-[#00B4D8]" data-id="element-246">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-247">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-248">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-249">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-250">
              Llegás a la cancha sin saber qué ejercicio vas a dar
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-251">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-252">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-253">
              Tus alumnos no progresan porque no hay secuencia clara
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-254">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-255">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-256">
              El 60% abandona antes del año y no sabés cómo frenarlo
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-257">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-258">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-259">
              Cuando llueve, cancelás y perdés el ingreso
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-260">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-261">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-262">
              No podés justificar un aumento de precio
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-263">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-264">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-265">
              Alumnos de distintos niveles juntos = caos
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-266">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-267">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-268">
              Fin de mes con cobro irregular e incómodo
            </p>
          </div>
        </div>

        <p className="text-[#00B4D8] text-2xl sm:text-3xl font-black mb-8" data-id="element-269">
          ¿Cuántas clases más vas a improvisar?
        </p>

        {/* Blue divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#00B4D8] to-transparent w-full" data-id="element-270" />
      </div>
    </section>;
}